import React, { useEffect, useMemo, useState } from 'react'
import { Button, InsideFooter } from '../../../../../components'
import useHistory from '../../../../../hooks/useHistory'
import useUrlParam from '../../../../../hooks/useUrlParam'
import ecbrApi from '../../../../../services/ecbrApi'
import { useInfinitePagination } from '../../../../../hooks/useInfinitePagination'
import { BoxCertificate, BoxContainer, StatusText } from './styles'
import ecbrDNA from '../../../../../assets/Icons/ecbrDna.svg'
import {
  CertificateStatus,
  CertificateStatusColors,
  getCertificateStatusText
} from '../../../../../constants/certificate'
import { useQuery } from 'react-query'
import LocalStorageService from '../../../../../services/LocalStorageService'
import { InvoiceStatus } from '../../../../../constants/invoice'

const pagination = { page: 1, take: 10 }

const UserCertificates = () => {
  const history = useHistory()
  const user = LocalStorageService.get('user') || {}
  const [company] = user.companies || []
  const [error, setError] = useState('')
  const [brandId] = useUrlParam('/user/brands/:id')
  const [searchParameters, _setSearchParameters] = useState({
    ...pagination
  })

  const {
    data: certificates,
    fetchNextPage,
    hasNextPage,
    isLastPage,
    isFetching,
    isLoading,
    refetch
  } = useInfinitePagination(
    'certificates',
    async (params) => {
      const { pageParam = searchParameters.page } = params
      return ecbrApi.certificates.getBrandCertificates(brandId, {
        ...searchParameters,
        page: pageParam || searchParameters.page
      })
    },
    {
      onSuccess: () => {
        setError('')
      },
      onError: () => {
        setError('Não foi possível carregar os dados')
      }
    }
  )

  const { data: invoices } = useQuery(
    'companyInvoices',
    async () => {
      const { data } = await ecbrApi.invoices.getAllActualCompanyInvoices({
        companyId: company.id
      })
      return data
    },
    {
      enabled: !!certificates?.length
    }
  )

  const certificateInvoice = useMemo(() => {
    if (!invoices?.length) return null
    const invoice = invoices.find((i) =>
      certificates?.find((c) => c.invoiceId === i.id)
    )
    return invoice
  }, [certificates, invoices])

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandId])

  const handleClickCertificate = (certificateId) => {
    if (certificateInvoice?.status === InvoiceStatus.PAID) {
      history.push(`/user/brands/${brandId}/certificates/${certificateId}`)
    } else {
      // TODO: show modal with 'not paid' message
    }
  }

  return (
    <>
      <h3>
        Aqui você pode gerenciar todas as certificações cadastradas na loja
      </h3>
      <BoxContainer>
        {isLoading && <p>Carregando...</p>}
        {!isFetching && !isLoading && !certificates?.length && (
          <p>Nenhum certificado encontrado</p>
        )}
        {error && <p>{error}</p>}
        {certificates?.map?.((certificate) => (
          <BoxCertificate
            key={certificate.id}
            {...(certificateInvoice?.status === InvoiceStatus.PAID &&
              certificate.status !== CertificateStatus.REPROVED && {
                onClick: () => handleClickCertificate(certificate.id)
              })}
          >
            <div>
              <img src={ecbrDNA} alt="ecbrDNA" />
              <h3>{certificate.product.name}</h3>
              <StatusText color={CertificateStatusColors[certificate.status]}>
                {certificateInvoice?.status === InvoiceStatus.PAID
                  ? getCertificateStatusText(certificate.status)
                  : 'Aguardando pagamento'}
              </StatusText>
            </div>
          </BoxCertificate>
        ))}

        {hasNextPage && !isLastPage && (
          <Button
            type="button"
            variant="outlined"
            text={isLoading || isFetching ? 'Carregando...' : 'Ver mais'}
            width="200px"
            height="40px"
            onClick={fetchNextPage}
          />
        )}
      </BoxContainer>
      <InsideFooter />
    </>
  )
}

export default UserCertificates
